// Initialize and add the map
const positionDepart = {lat: 15.9369699, lng: -61.2670961};
let map;
let panorama;
const resetMapButton = document.querySelector('#reset-map');
const backToMapButton = document.querySelector('#back-to-map');
const panoramaElement = document.querySelector('#panorama');

function initMap() {


    map = new google.maps.Map(document.getElementById('map'), {
        center: positionDepart,
        zoom: 2,
        streetViewControl: false // masque le petit bonhomme jaune
    });
    panorama = new google.maps.StreetViewPanorama(document.getElementById('panorama'), {
        position: {lat: 48.858227, lng: 2.294559},
        pov: {
            heading: 34,
            pitch: 10
        }
    });
    addMapListeners();
    panoramaElement.style.display = "none";
    backToMapButton.style.display = "none";
}

function addMapListeners(){
    resetMapButton.addEventListener("click", resetMap);
    backToMapButton.addEventListener("click", backToMap);
}

function addMarkerOnMap(dream){
    const marker = new google.maps.Marker({
        position:  dream.coordinates,
        map: map,
        icon: dream.done ? "images/marker_done.png" : "images/marker.png"
    });
    marker.addListener('click', function() {
        zoomOn(marker.getPosition());
    });
}

function zoomOn(position){
    map.setCenter(position);
    map.setMapTypeId('satellite');
    map.setZoom(20);
}

function resetMap(){
    map.setCenter( positionDepart);
    map.setMapTypeId('roadmap');
    map.setZoom(2);
}

function backToMap(){
    panoramaElement.style.display = "none";
    backToMapButton.style.display = "none";
    resetMapButton.style.display = "block";
}

function visitDreamOnMap(position){
    panorama.setPosition(position);
    panoramaElement.style.display = "block";
    backToMapButton.style.display = "block";
    resetMapButton.style.display = "none";
}


export {initMap,addMarkerOnMap,visitDreamOnMap};



//////////////////
// WEBPACK FOOTER
// ./src/map.js
// module id = 0
// module chunks = 0